import { BoxProps } from '@chakra-ui/react';

export const layoutStyled = (): BoxProps => ({
  display: 'flex',
  flexDirection: 'column',
  w: 'full',
});

export const containterStyle: BoxProps = {
  minH: '100vh',
  display: 'flex',
  w: '100vw',
  bg: 'bg.main',
  pos: 'relative',
};
